import Login from './login';
import ROLE from './roles';
import store from '../store';
class Gio {
  constructor(options) {
    let defaults = {
      id: 'b360751519d09828'
    };
    let data = { $gio: null };
    let _options = { ...defaults, ...data };
    Object.keys(_options).forEach(key => {
      this[key] = _options[key];
    });
    this.initial();
  }
  initial() {
    this.setScript(window, document, 'script', 'assets.giocdn.com/2.1/gio.js', 'gio');
    this.$gio = window.gio;
    this.$gio('init', this.id, {});
    //custom page code begin here
    //custom page code end here
    this.$gio('send');
    // this.sendUser();
  }
  setScript(e, t, n, g, i) {
    let tag;
    e[i] =
      e[i] ||
      function() {
        (e[i].q = e[i].q || []).push(arguments);
      };
    n = t.createElement('script');
    tag = t.getElementsByTagName('script')[0];
    n.async = 1;
    n.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + g;
    tag.parentNode.insertBefore(n, tag);
  }
  cleanUser() {
    this.$gio('clearUserId');
  }
  async sendUser() {
    let isLogin = Login.isLogin;
    let role = store.state.lastLoginType;
    if (isLogin && role === ROLE.STUDENT) {
      let status = await Login.getStatusData(ROLE.STUDENT, true);
      let year = new Date().getFullYear();
      if (status) {
        this.$gio('setUserId', status.user_id);
        this.$gio('people.set', {
          [`offer_letter_${year}`]: status.offer_letter,
          [`is_tuition_paid_${year}`]: status.is_tuition_paid,
          [`is_apply_paid_${year}`]: status?.activate_status_v5?.apply_paid,
          [`active_type_${year}`]: status?.activate_status_v5?.active_type
        });
      }
    }
  }
}
export default new Gio();
